/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_Project_7_ResultInputs */

const et_portfolio_project_7_result = /** @type {(inputs: Portfolio_Project_7_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konversioonid kasvasid 40% ja brändi usaldusväärsus tugevnes.`)
};

const en_portfolio_project_7_result = /** @type {(inputs: Portfolio_Project_7_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Increased conversions by 40% and strengthened brand credibility.`)
};

/**
* | output |
* | --- |
* | "Increased conversions by 40% and strengthened brand credibility." |
*
* @param {Portfolio_Project_7_ResultInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_project_7_result = /** @type {((inputs?: Portfolio_Project_7_ResultInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_Project_7_ResultInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_project_7_result(inputs)
	return en_portfolio_project_7_result(inputs)
});